import React from 'react';
import { EmptyTableIllustration } from './EmptyTableIllustration';

function resolveRowKey(row, rowKey, idx) {
  if (!rowKey) return idx;
  if (typeof rowKey === 'function') return rowKey(row);
  if (typeof rowKey === 'string') return row[rowKey] ?? idx;
  return idx;
}

export function DataTable({
  columns,
  rows,
  emptyText,
  emptyTitle,
  emptyDescription,
  loading = false,
  rowKey,
}) {
  if (loading) {
    return (
      <div className="admin-table-shell admin-table-shell--empty py-5 text-center">
        <div className="spinner-border text-primary" role="status" aria-label="Loading" />
      </div>
    );
  }

  const emptyMessage = emptyTitle || emptyText || 'No data to show';

  if (!rows?.length) {
    return (
      <div className="admin-table-shell admin-table-shell--empty">
        <div className="admin-table-empty">
          <EmptyTableIllustration />
          <p className="admin-table-empty-title mb-0">{emptyMessage}</p>
          {emptyDescription ? (
            <p className="text-secondary small mb-0 mt-1">{emptyDescription}</p>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="admin-table-shell">
      <div className="table-responsive">
        <table className="table table-sm align-middle mb-0 admin-data-table">
          <thead>
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  scope="col"
                  className={c.key === 'actions' ? 'text-end' : ''}
                  style={c.width ? { width: c.width } : undefined}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={resolveRowKey(row, rowKey, idx)}>
                {columns.map((c) => (
                  <td key={c.key} className={c.key === 'actions' ? 'text-end' : ''}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
